import { registerLocaleData } from "@angular/common";
import localeEN from "@angular/common/locales/en";
import localeNL from "@angular/common/locales/nl";
import localeRO from "@angular/common/locales/ro";

/**
 * The locales this application ships, registered under the ids
 * `ShellLocaleService` maps the three languages to.
 *
 * Shared between the app bootstrap and the test bundle on purpose. These used
 * to be three loose calls in main.ts, so a spec that rendered a date in
 * Romanian failed with "Missing locale data" - a harness problem wearing the
 * costume of a real one. Registered in one place, a spec fails only for the
 * reasons production would.
 *
 * Romanian was missing entirely until the shell started formatting dates in
 * the chosen language rather than always in Dutch.
 */
export function registerAppLocales(): void {
  registerLocaleData(localeNL, "nl-NL");
  registerLocaleData(localeEN, "en-GB");
  registerLocaleData(localeRO, "ro-RO");
}
